export const categoryTypes = {
  DISPLAY_CATEGORIES: "DISPLAY_CATEGORIES",
  GET_CATEGORY_DETAILS: "GET_CATEGORY_DETAILS",
};
